import { cva, type VariantProps } from 'class-variance-authority';
import React, { memo } from 'react';

import styles from './badge.module.scss';

const badgeVariants = cva(styles.badge, {
  variants: {
    variant: {
      default: styles['badge--default'],
      secondary: styles['badge--secondary'],
      destructive: styles['badge--destructive'],
      outline: styles['badge--outline'],
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>;

const Badge = memo(({ className, variant, ...props }: BadgeProps) => (
  <div className={badgeVariants({ variant, className })} {...props} />
));
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
export type { BadgeProps };
